import axios from 'axios';

export const ldapAuthenticate = (ldapAuthUrl,params) => {
    return axios.post(ldapAuthUrl, params, {
        headers: { 'Content-Type': 'application/json' },
        timeout: 10000,
    }).then(res => res.data);
};
